<div
  class="app-shell"
  [class.app-shell--scanner-read]="scannerReadLayout"
  [class.app-shell--auth]="authLayout"
>
  <a class="skip-link" href="#main-content">Pular para o conteúdo</a>

  <header class="app-header" role="banner">
    <div class="header-overlay">
      <div class="logo-wrapper">
        <img src="assets/logo.svg" width="160" height="48" alt="Seu Ingresso Aqui" />
      </div>
    </div>
  </header>

  <main id="main-content" class="main-wrapper" role="main" tabindex="-1">
    <div class="main-content app-main-content">
      <router-outlet />
      @if (!loaded) {
        <div class="app-route-loading" role="status" aria-live="polite" aria-busy="true" aria-label="Carregando evento">
          <div class="app-route-loading__card">
            <div class="app-route-loading__spinner" aria-hidden="true"></div>
            <p class="app-route-loading__text">Carregando evento…</p>
          </div>
        </div>
      }
    </div>
  </main>

  <footer class="app-footer" role="contentinfo">
    <div class="footer-container">
      <div class="footer-bottom">
        <div class="footer-bottom-logo">
          <img
            [src]="frontendUrl + '/assets/images/logo-vetor.svg'"
            width="180"
            height="40"
            alt="Seu Ingresso Aqui"
            loading="lazy"
          />
        </div>
        <div class="footer-bottom-text">
          <span>Todos os direitos reservados SEU INGRESSO AQUI © 2026.</span>
        </div>
      </div>
    </div>
  </footer>
</div>

<p-toast
  [key]="toastKey"
  position="top-center"
  [baseZIndex]="12000"
  [breakpoints]="{ '640px': { width: '100%', right: '0', left: '0', margin: '0.75rem' } }"
/>

<ngx-spinner
  bdColor="rgba(0, 0, 0, 0.8)"
  size="medium"
  color="#fff"
  type="ball-atom"
  [fullScreen]="true"
  aria-busy="true"
  aria-live="polite"
>
  <p class="spinner-label">Carregando…</p>
</ngx-spinner>
